import { api } from './api';

export const visitorService = {
    // Visitor management
    createVisitor: async (visitorData) => {
        // Format phone number if present
        if (visitorData.phone) {
            visitorData.phone = visitorData.phone.trim();
            // Ensure it starts with +
            if (!visitorData.phone.startsWith('+')) {
                visitorData.phone = '+' + visitorData.phone;
            }
        }
        const response = await api.post('/visitors', visitorData);
        return response.data;
    },
    
    getAllVisitors: async () => {
        const response = await api.get('/visitors');
        // Add last visit information to each visitor
        const visitorsWithLastVisit = await Promise.all(response.data.map(async visitor => {
            try {
                const lastVisitResponse = await api.get(`/visitors/${visitor.id}/last-visit`);
                return {
                    ...visitor,
                    last_visit: lastVisitResponse.data?.visit_date
                };
            } catch (error) {
                console.error(`Error fetching last visit for visitor ${visitor.id}:`, error);
                return visitor;
            }
        }));
        return visitorsWithLastVisit;
    },
    
    searchVisitors: async (query) => {
        try {
            const response = await api.get('/visitors/search-visitors', {
                params: { query }
            });
            return response.data;
        } catch (error) {
            console.error('Search error:', error);
            throw error;
        }
    },

    convertToMember: async (visitorId) => {
        const response = await api.post(`/visitors/${visitorId}/convert-to-member`);
        return response.data;
    },

    checkExistingMember: async (visitorId) => {
        const response = await api.get(`/visitors/${visitorId}/check-existing-member`);
        return response.data;
    }
}; 